import { useEffect, useState } from 'react';
import './App.css';
import Numpuzzle from './numpuzzle';
import Todolist from './todolist';
import Todo from './Demo';
import Clc from './Clc';
import Tictactae from './tictactae';
import Result from './Result';
import Demo from './Demo';
import Api from './Api';


function App() {
  
  return (
    <>
    {/* <Clc/> */}
    {/* <Tictactae/> */}
    {/* <Numpuzzle/> */}
    {/* <Todolist/> */}
    <Todo/>
    {/* <Result/> */}
    {/* <Demo/> */}

    {/* <Api/> */}
    </>
  );
}

export default App;
